import React, {useState, useEffect} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import {
  apollo_useStyles,
  getModalStyle,
} from "../../atom/Apollo_styles";
import {BillingResource, BillingResourceRequest} from "./Apollo_MasterModel";
import {
  apollo_billing_resource_path,
} from "../../atom/Apollo_links";
import {ApolloMessage} from "../../atom/Apollo_Mesasge"
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";

import TextField from "@material-ui/core/TextField/TextField";
import {useForm} from "react-hook-form";
// メッセージ定義
import {
  GetMessage,
  UI_MASTER_BILLING_MODAL,
} from "../../atom/Apollo_MesasgeDefinition";
// ドロワー(認証期間切れの場合にドロワーを閉じるため)
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// MODAL
import Card from "@material-ui/core/Card/Card";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Grid from "@material-ui/core/Grid";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import classNames from "classnames";
import Box from "@material-ui/core/Box";
import {checkInvalidCharForName} from "../../common/Apollo_CommonUtil";

interface MasterBillingModalProps {
  kind: any;        // 追加, 登録, 更新 などボタン表示名
  isDisabled: any   // ボタン不活化
  billingId: any    // 請求リソースID
  setRead: any      // 再表示関数
  read: any         // 再表示数
}

  // 請求リソース登録・変更モーダル表示
export default function ApolloMasterBillingModal(props: MasterBillingModalProps) {

  const {register, handleSubmit, errors} = useForm();
  const classes = apollo_useStyles();
  const buttonClass = classNames(classes.button, classes.radioSubmit);
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [billing, setBilling] = React.useState<BillingResource>();

  // ドロワー(認証期間切れの場合にドロワーを閉じるため)
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  // 請求リソース取得
  useEffect(() => {
    // 更新の場合
    if (props.billingId !== 0) {
      const url = apollo_billing_resource_path + "/" + props.billingId;
      ApolloAxios.get(url).then(response => {
        if (response.data.resultCode === 0) {
          setBilling(response.data.result);
        } else {
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_MASTER_BILLING_MODAL,"E","0"),
            },
          });
        }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_MASTER_BILLING_MODAL,"E","0"), data, setmsg, history, setDrawerState, drawerState)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    }
  },[open]);
  
  const bStyle = {
    top: "40%",
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  // 作成・更新ボタンクリック
  const onSubmit = handleSubmit(async (body: any) => {
    // 作成・更新リクエスト作成
    const req: BillingResourceRequest = {
      billingName: body.billingName,
      creditLimitAmount: Number(body.creditLimitAmount),
    };

    // 追加の場合
    if (props.billingId === 0) {
      const url = apollo_billing_resource_path;
      ApolloAxios.post(url, req).then(response => {
        if (response.data.resultCode === 0) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: GetMessage("0",UI_MASTER_BILLING_MODAL,"I","0"),
            }
          });
          setBilling(response.data.result);
          props.setRead(props.read + 1);
        } else {
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_MASTER_BILLING_MODAL,"E","1"),
            }
          });
        }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_MASTER_BILLING_MODAL,"E","1"), data, setmsg, history, setDrawerState, drawerState)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    } else {
      // 更新の場合
      const url = apollo_billing_resource_path + "/" + props.billingId;
      ApolloAxios.put(url, req).then(response => {
        if (response.data.resultCode === 0) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: GetMessage("0",UI_MASTER_BILLING_MODAL,"I","1")
            }
          });
        } else {
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_MASTER_BILLING_MODAL,"E","2"),
            }
          });
        }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_MASTER_BILLING_MODAL,"E","2"), data, setmsg, history, setDrawerState, drawerState)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    }
    setOpen(false);
  });

  return (
    <React.Fragment>
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        disabled={props.isDisabled ? true : false}
        onClick={handleOpen}>
        {props.kind}
      </Button>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleModalClose}
      >
      <form noValidate onSubmit={onSubmit}>
        <div style={modalStyle} className={classes.paper}>
          <React.Fragment>
            <Card className={classes.root} square variant="outlined">
              <CardContent className={classes.flame}>
                <Box>
                  <Grid item xs={12}>
                    <TextField
                      disabled
                      id="billingId"
                      name="billingId"
                      label="請求ID"
                      key={billing?.billingId ? "Loaded" : "Loading"}
                      fullWidth
                      defaultValue={props.billingId !== 0 ? props.billingId : ""}
                      autoComplete="請求ID"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      id="billingName"
                      name="billingName"
                      label="請求リソース名"
                      key={billing?.billingName ? "Loaded" : "Loading"}
                      inputRef={register({
                        required: "必須入力項目です。",
                        maxLength: {
                          value: 255,
                          message: "255文字以内で入力して下さい。"
                        },
                        validate: (e: string) => {
                          const errorMessage = checkInvalidCharForName(e)
                          if(errorMessage) {
                            return errorMessage
                          }},
                      })}
                      fullWidth
                      defaultValue={props.billingId !== 0 ? billing?.billingName : ""}
                      autoComplete="請求リソース名"
                      helperText={errors.billingName && errors.billingName.message}
                      error={errors.billingName ? true : false}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="creditLimitAmount"
                      name="creditLimitAmount"
                      label="与信限度額"
                      key={billing?.creditLimitAmount ? "Loaded" : "Loading"}
                      defaultValue={props.billingId !== 0 ? billing?.creditLimitAmount : ""}
                      inputProps={{type: 'number'}}
                      inputRef={register({
                        required: "必須入力項目です。",
                        min: {
                          value: 1,
                          message: "1 以上を入力して下さい。"
                        },
                        max: {
                          value: Number.MAX_SAFE_INTEGER,
                          message: Number.MAX_SAFE_INTEGER.toLocaleString() + " 以下を入力して下さい。"
                          // value: 2**31-1,
                          // message: Number(2**31-1).toLocaleString() + " 以下を入力して下さい。"
                        },
                      })}
                      required
                      fullWidth
                      autoComplete="与信限度額"
                      helperText={errors.creditLimitAmount && errors.creditLimitAmount.message}
                      error={errors.creditLimitAmount ? true : false}
                    />
                  </Grid>
                </Box>
                <Button onClick={handleModalClose} variant="outlined" color="primary" className={buttonClass} style={bStyle}>
                  戻る
                </Button>
                <Button onClick={onSubmit} variant="outlined" color="primary" className={buttonClass} style={bStyle}>
                  {props.kind}
                </Button>
              </CardContent>
              <CardActions className={classes.cardaction}>
              </CardActions>
            </Card>
          </React.Fragment>
        </div>
        </form>
      </Modal>
    </React.Fragment>
  );
}

